import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AdminSteps from '../common/AdminSteps';
import { Row, Col } from 'react-bootstrap';
import * as courseActions from '../../actions/coursesActionCreators';
import * as runActions from '../../actions/runsActionCreators';
import Spinner from 'react-spinkit';
import label from '../../utils/lngEn';
import StudentForm from './StudentForm';
import { browserHistory } from 'react-router';
import ConfirmDeleteModal from '../common/ConfirmDeleteModal';
import DiagnosticsModal from '../common/DiagnosticsModal'
import { openInNewTab, serializeParams } from '../../utils/utils';
import SelectionStatusBox from './SelectionStatusBox';
import AssignmentList from './AssignmentList';
import Waitlists from './Waitlists';

class AddDropStudentPage extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      studentDetails: {
        id: null
      },
      isFetchedStudent: false
    };

    this.handleStudentFormSubmit = this.handleStudentFormSubmit.bind(this);
    this.closeDeleteStudentModal = this.closeDeleteStudentModal.bind(this);
    this.handleDeleteStudent = this.handleDeleteStudent.bind(this);
    this.updateWaitlists = this.updateWaitlists.bind(this);
  }

  async componentDidMount() {
    const { courses = [] } = this.props;
    if (!this.props.run.id) {
      this.props.runActions.getRun();
    }
    if (this.props.studentId) {
      this.setState({ studentLoaded: false });
      this.props.studentActions.getStudentById(this.props.studentId).then(() => {
        let student = Object.assign({}, this.props.student);
        if (student.base_budget) {
          student.base_budget = student.base_budget / 100;
        }
        if (student.effective_budget) {
          student.effective_budget = student.effective_budget / 100;
        }

        this.props.studentActions.getStudentAssignments(this.props.studentId).then((res) => {
          this.setState({ assignments: res.results });
        });
        this.props.studentActions.getStudentWaitlists(this.props.studentId).then((res) => {
          this.setState({ waitlists: res.results });
        });

        this.setState({ studentDetails: student })
      });
    }
    if (courses.length <= 0) {
      await this.props.courseActions.getAllCourses()
    }
    this.setState({ isFetchedStudent: true });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.student.id && nextProps.student != this.props.student) {
      this.setState({ studentLoaded: false });
      let student = Object.assign({}, nextProps.student);
      if (student.base_budget) {
        student.base_budget = student.base_budget / 100;
      }
      if (student.effective_budget) {
        student.effective_budget = student.effective_budget / 100;
      }
      this.setState({ studentDetails: student, studentLoaded: true });
    }
    if (this.props.studentId && nextProps.courses != this.props.courses) {
      this.setState({ coursesLoaded: true });
    }
  }


  // Student form - Handle submit
  handleStudentFormSubmit = (values) => {
    if (typeof values.base_budget == 'object') {
      values.base_budget = values.base_budget.value;
    }
    if (values.id) {
      this.props.studentActions.putStudent(values).then(() => {
        this.props.studentActions.getStudentById(this.props.studentId);
        this.props.studentActions.getAllStudents();
      });
    } else {
      this.props.studentActions.createStudent(values).then(res => {
        this.props.courseActions.getAllCourses().then(() => {
          this.props.studentActions.getStudentById(res.id);
          this.props.studentActions.getAllStudents();
          this.setState({ coursesLoaded: true });
          browserHistory.push('/administer/' + localStorage.getItem('run') + '/student/' + res.id);
        });
      });
    }
  }

  handleEmulateStudent = (student, runSlug) => () => {
    this.props.studentActions
      .emulateStudent(student.id)
      .then(authData => {
        const urlParams = {
          token: authData.token,
          expiration_date: authData.expiration_date,
          viewAs: 'emulate',
          target: student.user.email
        };
        const emulateUrl = `/rank/${runSlug}/login?${serializeParams(urlParams)}`;
        openInNewTab(emulateUrl);
      })
      .catch(err => console.log(err));
  };

  // Delete Student
  openDeleteStudentModal = () => () => {
    this.setState({ showConfirmStudentDelete: true });
  };

  handleDeleteStudent() {
    this.props.studentActions.deleteStudent(this.props.studentId).then(() => {
      this.props.studentActions.getAllStudents();
      browserHistory.push('/administer/' + localStorage.getItem('run') + '/students');
    });
  }

  closeDeleteStudentModal() {
    this.setState({ showConfirmStudentDelete: false });
  }

  updateWaitlists() {
    this.props.studentActions.getStudentWaitlists(this.props.studentId).then((res) => {
      this.setState({ waitlists: res.results });
    });
  }

  render() {
    const { student, courses, run, courseActions, commonComponents } = this.props;
    const { isFetchedStudent, waitlists, assignments } = this.state;
    const { assignment_complete } = run;

    return (
      <Col md={12}>
        <div className="page-title">Manage Student</div>
        <AdminSteps active="-1" label={this.props.run.slug} assignment_complete={assignment_complete} />
        {this.props.studentId ? (
          <button className="btn btn-ter pull-right delete-course" onClick={this.openDeleteStudentModal()}>
            Delete Student
          </button>
        ) : null}
        <Row>
          <Col md={8}>
            {(this.props.studentId && this.state.studentDetails.id != null) || !this.props.studentId ? (
              <div>
                {this.props.studentId ? (
                  <div className="page-subtitle">
                    <span className="sub-title-gray mr-2">{label.student}</span>
                    <span>{student.user.email}</span>
                    <button onClick={this.handleEmulateStudent(student, run.slug)} className="btn btn-ter emulate-btn">
                      EMULATE
                  </button>
                  </div>
                ) : (
                  <div className="page-subtitle">Create New Student</div>
                )}

                {this.props.studentId && this.props.student.id && this.state.studentLoaded ? (
                  <StudentForm
                    onSubmit={this.handleStudentFormSubmit}
                    adjustedBudget={this.props.student.effective_budget}
                    initialValues={this.state.studentDetails}
                    assignment_complete={assignment_complete}
                  />
                ) : null}
                {!this.props.studentId && !this.state.studentLoaded ? (
                  <StudentForm
                    onSubmit={this.handleStudentFormSubmit}
                    initialValues={{ base_budget: 100 }}
                    assignment_complete={assignment_complete}
                  />
                ) : null}
                {this.props.studentId ? (
                  <div>
                    <div className="mt-6">
                      <AssignmentList
                        courses={courses}
                        items={assignments}
                        isLoading={!isFetchedStudent}
                        runSlug={run.slug}
                      />
                    </div>
                    <div className="mt-6">
                      <Waitlists
                        courses={courses}
                        items={waitlists}
                        isLoading={!isFetchedStudent}
                        runSlug={run.slug}
                        student={student}
                        courseActions={courseActions}
                        updateWaitlists={this.updateWaitlists}
                      />
                    </div>
                    {commonComponents.StudentGroups}
                    <div ref="restrictions">
                      {commonComponents.RestrictionReleases}
                    </div>
                  </div>
                ) : null }
              </div>
            ) : (
                <Spinner spinnerName="three-bounce" />
              )}
          </Col>
          <Col md={4}>
            {this.props.studentId ? (
              <SelectionStatusBox
                assigned_credits={student.assigned_credits}
                pending_request_count={student.pending_request_count}
                last_login={student.last_login}
                is_eliciting={run.is_eliciting}
              />
            ) : null }
            <button className="btn btn-ter" style={{marginTop: '20px'}} onClick={() => this.setState({showDiagnosticsModal: true})}>
              Run Diagnostic
            </button>
            
          </Col>
        </Row>
        <DiagnosticsModal
          studentId={this.props.studentId}
          showModal={this.state.showDiagnosticsModal}
          onCancel={() => this.setState({ showDiagnosticsModal: false })}
        />
        <ConfirmDeleteModal
          closeModal={this.closeDeleteStudentModal}
          showModal={this.state.showConfirmStudentDelete}
          onCancel={this.closeDeleteStudentModal}
          customTitle={this.props.student.user.email}
          customMsg={label.deleteStudentCustomMsg}
          confirmButtonTitle="Delete"
          onConfirm={this.handleDeleteStudent}
        />

      </Col>
    );
  }
}

function mapStateToProps(state, ownProps) {
  let studentId = null;
  if (ownProps.params.id) {
    studentId = ownProps.params.id;
  }
  return {
    run: state.run,
    studentId: studentId,
    student: state.student,
    groups: state.groups,
    courses: state.courses,
    school: state.school,
    waitlists: state.waitlists,
    assignments: state.assignments
  };
}

function mapDispatchToProps(dispatch) {
  return {
    courseActions: bindActionCreators(courseActions, dispatch),
    runActions: bindActionCreators(runActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddDropStudentPage);



// WEBPACK FOOTER //
// ./src/components/students/AddDropStudentPage.js